import React, { useEffect, useState, useRef } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button';
import useColor from '../../context/themeContext';
import { modalGroup } from '../../classes'
import serviceAdmin from '../../services/serviceAdmin';
import Grid from "@material-ui/core/Grid";
import TableSearchGroup from '../Table/TableSearchGroup'
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import InfoIcon from '@material-ui/icons/Info';
import useAlert from '../../hooks/useAlert'
import FullTextField from '../StyledComponent/FullTextField'
import CustomTooltip from '../StyledComponent/CustomTooltip'



export default function ModalGroup(props) {
  

  const [options, setAlert] = useAlert()
  const { COLORS } = useColor();
  const useStyles = makeStyles((theme) => (modalGroup(COLORS)));
  const classes = useStyles();
  const isMount = useRef(true);

  const [users, setUsers] = useState([])
  const [roles, setRoles] = useState([])
  const [groups, setGroups] = useState([])
  const [groupsIds, setGroupsIds] = useState([])
  const [rolesIds, setRolesIds] = useState("")
  const [search, setSearch] = useState("")
  const [count, setCount] = useState(0)
  const [selectedIds, setSelectedIds] = useState([])
  const [filter, setFilter] = useState(true);
  const [pageUser, setPageUser] = useState(1)
  const [page, setPage] = useState(0)
  const [rowsUser, setRowsUser] = useState(10)
  const [checked, setChecked] = useState(false)
  const [checkedActive, setCheckedActive] = useState(false)
  const [timeUpload, setTimeUpload] = useState("")
  const [backdrop, setBackdrop] = useState(false)
  const [selected, setSelected] = useState([]);
  const [reload, setReload] = useState(false);


  const setchecked = () => {
    setChecked(!checked);
  }

  const setselected = (input) => {
    if (input?.length > 100) {
      setAlert(true, "Limite di 100 utenti raggiunto", "warning")
    } else {
      setSelected(input)
    }
  }
  const setcheckedactive = () => {
    setCheckedActive(!checkedActive);
  }


  const setbackdrop = (input) => {
    setBackdrop(input);
  }

  const setpageuser = (input) => {
    setPageUser(input)
  }

  const setpage = (input) => {
    setPage(input)
  }

  const setrowsuser = (input) => {
    setRowsUser(input)
  }

  const setusersids = (input) => {
    setSelectedIds(input)
  }

  const handleChangeGroups = (e) => {
    if (!e.target.value.find(el => el === "ALL")) {
      setGroupsIds(e.target.value)
    }
  }

  const setAllGroups = () => {
    const g_ids = groups.map(group => group.id);
    setGroupsIds(g_ids);
  }
  const handleChangeRoles = (e) => {

    setRolesIds(e.target.value)

  }

  const handleChangeSearch = (e, newvalue) => {
    setSearch(e.target.value);
    setPageUser(1);
  }

  const handleClose = () => {
    setSelectedIds([]);
    props.setOpen(false);
  };

  useEffect(() => {
    if (checkedActive || rolesIds || groupsIds.length > 0) {
      setChecked(false)
    }
  }, [checkedActive, rolesIds, groupsIds])

  useEffect(() => {
    if (checked) {
      setCheckedActive(false);
      setRolesIds("");
      setGroupsIds([]);
    }
  }, [checked])

  useEffect(() => {
    if (selectedIds.length > 0) {
      setChecked(false);
      setCheckedActive(false);
      setRolesIds("");
      setGroupsIds([]);
    }
  }, [selectedIds])

  useEffect(() => {

    serviceAdmin.getService(`v1/roles/`)
      .then(res => {
        if (isMount.current) {
          if (res.data.data) {
            setRoles(res.data.data);
          }
        }
      }).catch(err => {
        console.log(err);
      })

    serviceAdmin.getService(`v1/groups/`)
      .then(res => {
        if (isMount.current) {
          if (res.data.data) {
            const filterGroup = res.data.data.filter(group => group.id !== props.group.id);
            setGroups(filterGroup);
          }
        }
      }).catch(err => {
        console.log(err);
      })

    return () => {
      setTimeUpload(false)
      isMount.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!props.open) {
      setGroupsIds([])
      setChecked(false)
      setCheckedActive(false)
      setRolesIds("")
      setSearch("")
    }
  }, [props.open])

  useEffect(() => {
    let url = `v1/users/?search=${search}&page=${pageUser}&page_items=${rowsUser}`;
    if (props.group.id) url += `&group_id_not=${props.group.id}`;

    const searchTime = setTimeout(() => {
      if ((search.length > 1 || search === "") && rowsUser) {
        serviceAdmin.getService(url)
          .then(res => {
            if (isMount.current) {
              if (res.data.data) {
                setUsers(res.data.data);
                setCount(res.data.meta.pagination.items_count)
                setPage(pageUser - 1)
                setBackdrop(false)
              }
            }
          }).catch(err => {
            if (err?.status === 404) {
              setBackdrop(false)
            }
          })
      }
    }, 200)

    return () => {
      clearTimeout(searchTime)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, pageUser, rowsUser, groups, reload])

  function clean(obj) {
    for (let propName in obj) {
      if ((obj[propName] === "" || obj[propName] === false) || (Array.isArray(obj[propName]) && obj[propName].length === 0)) {
        delete obj[propName];
      }
    }
  }

  const addUsers = () => {
    let params;

    if (selectedIds.length > 0) {
      params = {
        "users_ids": selectedIds,
      }
    } else if (rolesIds === "" && groupsIds.length === 0 && !checkedActive) {
      params = {
        "all_users": true,
      }
    } else {
      params = {
        "all_users": true,
        "filters": {
          "role_id": rolesIds,
          "groups_ids": groupsIds,
          "users_is_active": checkedActive
        }
      }
      clean(params?.filters)
    }
    setTimeUpload(true);
    serviceAdmin.postService(`v1/groups/${props.group.id}/users/`, params)
      .then(res => {

        if (res.status === 200) {
          props.setReloadCount();
          setTimeUpload(false);
          const count_operation = res?.data?.data?.goup_users_count - props?.user;
          setAlert(true, `${count_operation ? (count_operation === 1 ? count_operation + " Utente aggiunto" : count_operation + " Utenti aggiunti") : "0 Utenti aggiunti"} al gruppo`, "success");
          props.setReload();
          props.setreload();
          setSelected([])
          setReload(!reload)
        }
      }).catch(err => {
        console.log(err);
      })
  }

  return (
    <div >

      <Grid container spacing={3}>

        <Grid item xs={12}>

          <Grid item xs={12} container justify="center">
            <ButtonGroup>
              <Button className={filter ? classes.btn_active : classes.btn_not_active} onClick={() => { setFilter(true); setselected([]) }}>Filtra utenti da aggiungere</Button>
              <Button className={!filter ? classes.btn_active : classes.btn_not_active} onClick={() => setFilter(false)}>Cerca utenti da aggiungere</Button>
            </ButtonGroup>
          </Grid>

          <Grid style={{ marginTop: "30px" }} item xs={12} container justify="center">
            <span style={{ color: "#0000008A" }}>
              {count + " utenti da poter aggiungere al gruppo"}
            </span>
          </Grid>

          {!filter &&
            <div style={{ display: "flex" }}>
              <FullTextField style={{ background: "#f1f1f1", minWidth: "180px", backgroundColor: "#f1f1f1", borderRadius: "20px", marginTop: "30px" }} onChange={handleChangeSearch} label="Cerca..." variant="outlined" />
            </div>
          }

          <TableSearchGroup
            selected={selected}
            setSelected={setselected}
            setBackdrop={setbackdrop}
            backdrop={backdrop}
            checkedActive={checkedActive}
            checked={checked}
            setChecked={setchecked}
            setCheckedActive={setcheckedactive}
            setPageUser={setpageuser}
            setPage={setpage}
            page={page}
            setRowsUser={setrowsuser}
            users={users}
            count={count}
            setUsersIds={setusersids}
            handleChangeRoles={handleChangeRoles}
            handleChangeGroups={handleChangeGroups}
            roles={roles}
            groups={groups}
            role={rolesIds}
            group={groupsIds}
            filter={filter}
            setAllGroups={setAllGroups}
          />

        </Grid>

      </Grid>

      <Paper elevation={3} className={classes.save}>

        <Button onClick={handleClose} className={classes.btn_del}>Annulla</Button>
        <div className={classes.wrapper}>
          <Button onClick={addUsers} disabled={timeUpload || selectedIds.length > 0 || rolesIds || groupsIds.length > 0 || checked || checkedActive ? false : true} className={classes.btn_save}>Aggiungi</Button>
          {timeUpload && <CircularProgress size={24} className={classes.buttonProgress} />}
        </div>
        {timeUpload &&
          <CustomTooltip
            title="Se sono stati selezionati molti utenti potrebbe volerci un pò, ma nel frattempo puoi fare altro l'operazione continuerà"
          >
            <InfoIcon style={{ fontSize: "24px", color: COLORS.primary }} />
          </CustomTooltip>
        }
      </Paper>

    </div>
  );
}